import React, { useState, useEffect } from 'react';
import { CiMenuKebab } from 'react-icons/ci';
import { FiCheckCircle, FiAlertCircle, FiEdit, FiXCircle } from 'react-icons/fi';
import CustomModel from '../../../../../../components/common/CustomModel';
import CustomSelect from '../../../../../../components/common/CustomSelect';
import { showErrorToast, showSuccessToast } from '../../../../../../components/Constant/Notification';
import ProspectPropertyService from '../../../../../Service/ProspectPropertyService';
import UserService from '../../../../../../GlobalSetupComponents/Services/UserService';
import { formatDate, formatDateForInput } from '../../../../../../utils/dateFormatter';
import { getPriorityBadgeColor, periotyQueryEnum, queryCategories } from '../../../../../Enum/QueryEnum';
import { userUid } from '../../../../../../utils/storage';
import { Divider, MenuItem } from '../../../../../../components/Constant/Constant';
import ConfirmationModal from '../../../../../../components/shareableContainer/ConfirmationModal';

const VAOAnalysis = ({ propertyId, setPropertyData,setTriggerFetch , propertyData, assignedUserData, isDropped }) => {
  // State management for checkbox selections
  const [fmaCleared, setFmaCleared] = useState(false);
  const [aRecordCleared, setARecordCleared] = useState(false);
  const [vaoAnalysisCleared, setVaoAnalysisCleared] = useState(false);
  const [remarks, setRemarks] = useState('');
  const [modifiedBy, setModifiedBy] = useState({});

  // Modal state management
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  // Fetch data and initialize state
  const fetchData = async () => {
    try {
      const response = await ProspectPropertyService.getStageWiseProperties({
        propertyId: propertyId,
        stage: 'Analysis',
      });
      const data = response.data?.data;
      if (data && data.vaoAnalysisRecords && data.vaoAnalysisRecords.records) {
        const vaoRecords = data.vaoAnalysisRecords.records;
      
        if (vaoRecords.length > 0) {
          const record = vaoRecords[0]; // Use the first record for initialization
          setFmaCleared(record.fmaIsAllClear || false);
          setARecordCleared(record.aRecordIsAllClear || false);
          setVaoAnalysisCleared(record.vaoAnalysisIsAllClear || false);
          setRemarks(record.notes || '');
          setModifiedBy(record.modifiedBy || {});
        
      
         
        }
      }
    } catch (error) {
      console.error('Error loading VAO analysis data:', error);
      showErrorToast('Failed to load VAO analysis data');
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchData();
  }, [propertyId]);

  // Handler functions
  const handleCheckboxClick = (type) => {
    setPendingAction(type);
    setShowConfirmModal(true);
  };

  const handleConfirmAction = () => {
    switch (pendingAction) {
      case 'fma':
        setFmaCleared(true);
        //showSuccessToast('FMA marked as clear');
        break;
      case 'aRecord':
        setARecordCleared(true);
       // showSuccessToast('A Record marked as clear');
        break;
      case 'vaoAnalysis':
        setVaoAnalysisCleared(true);
       // showSuccessToast('VAO Analysis marked as clear');
        break;
      default:
        break;
    }
    setShowConfirmModal(false);
    setPendingAction(null);
  };

  const handleCloseModal = () => {
    setShowConfirmModal(false);
    setPendingAction(null);
  };

  const handleUndo = (type) => {
    switch (type) {
      case 'fma':
        setFmaCleared(false);
        //showSuccessToast('FMA status cleared');
        break;
      case 'aRecord':
        setARecordCleared(false);
       // showSuccessToast('A Record status cleared');
        break;
      case 'vaoAnalysis':
        setVaoAnalysisCleared(false);
       // showSuccessToast('VAO Analysis status cleared');
        break;
      default:
        break;
    }
  };

  const handleSave = async () => {
    try {
      // Construct the analysisData array, only including marked items
      const analysisData = [
        {
          type: 'FMA is all clear',
          isCompleted: fmaCleared,
          fieldUpdatedBy: fmaCleared ? userUid : undefined,
        },
        {
          type: 'A Record is all clear',
          isCompleted: aRecordCleared,
          fieldUpdatedBy: aRecordCleared ? userUid : undefined,
        },
        {
          type: 'VAO Analysis is all clear',
          isCompleted: vaoAnalysisCleared,
          fieldUpdatedBy: vaoAnalysisCleared ? userUid : undefined,
        },
      ]

      // Validate that there is at least one marked analysis or remarks
      if (analysisData.length === 0 && !remarks) {
        showErrorToast('Please mark at least one analysis or provide remarks');
        return;
      }

      // Construct the payload
      const dataToSave = {
        propertyId: propertyId,
        stageType: 'VAO Analysis',
        analysisData: analysisData,
        updatedBy: userUid,
        notes: remarks || '',
      };

      // Make the API call to save the data
      const response = await ProspectPropertyService.analysisDocumentMarkUpdate(dataToSave);
      if (response.status === 200 || response.status === 201) {
        showSuccessToast('Legal analysis saved successfully');
        setTriggerFetch(prev => !prev);
        await fetchData();
      } else {
        showErrorToast('Failed to save legal analysis');
      }
    } catch (error) {
      showErrorToast('Failed to save legal analysis');
      console.error('Error saving legal analysis:', error);
    }
  };

  return (
    <div className="">
      <div>
        <div className="text-sm flex gap-3 w-[70%] border border-gray-300 p-3 rounded-[10px] text-slate-500">
          <div>Assigned Front end person - </div>
          <span className="text-blue-500">{assignedUserData[2]?.name}</span>
        </div>

        <div className="">
          <div className="w-[70%] flex flex-col gap-2 mt-4">
            {/* FMA Clear Button */}
            <div className="flex items-center gap-2 mt-4">
              <button
                onClick={() => handleCheckboxClick('fma')}
                className={`flex-1 px-4 py-2 rounded-md flex items-center justify-center gap-2 transition-colors ${
                  fmaCleared
                    ? 'bg-green-100 text-green-700 border border-green-300'
                    : isDropped
                    ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                    : 'bg-gray-200 text-orange-500 hover:bg-gray-300'
                }`}
                disabled={fmaCleared || isDropped}
              >
                {fmaCleared && <FiCheckCircle className="text-green-600" />}
                <span>FMA is all clear</span>
                { fmaCleared && modifiedBy?.name && (
                  <span className="text-xs text-green-600 font-medium ml-2">
                    (Marked by "{modifiedBy?.name} ({modifiedBy?.role})")
                  </span>
                )}
              </button>
              {fmaCleared && (
                <button 
                  onClick={() => handleUndo('fma')} 
                  disabled={isDropped}
                  className={`${isDropped ? 'text-gray-400 cursor-not-allowed' : 'text-blue-500'}`}
                >
                  Undo
                </button>
              )}
            </div>

            {/* A Record Clear Button */}
            <div className="flex items-center gap-2 mt-4">
              <button
                onClick={() => handleCheckboxClick('aRecord')}
                className={`flex-1 px-4 py-2 rounded-md flex items-center justify-center gap-2 transition-colors ${
                  aRecordCleared
                    ? 'bg-green-100 text-green-700 border border-green-300'
                    : isDropped
                    ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                    : 'bg-gray-200 text-orange-500 hover:bg-gray-300'
                }`}
                disabled={aRecordCleared || isDropped}
              >
                {aRecordCleared && <FiCheckCircle className="text-green-600" />}
                <span>"A" Record is all clear</span>
               { aRecordCleared && modifiedBy?.name && (
                  <span className="text-xs text-green-600 font-medium ml-2">
                    (Marked by "{modifiedBy?.name} ({modifiedBy?.role})")
                  </span>
                )}
              </button>
              {aRecordCleared && (
                <button 
                  onClick={() => handleUndo('aRecord')} 
                  disabled={isDropped}
                  className={`${isDropped ? 'text-gray-400 cursor-not-allowed' : 'text-blue-500'}`}
                >
                  Undo
                </button>
              )}
            </div>

            {/* VAO Analysis Clear Button */}
            <div className="flex items-center gap-2 mt-4">
              <button
                onClick={() => handleCheckboxClick('vaoAnalysis')}
                className={`flex-1 px-4 py-2 rounded-md flex items-center justify-center gap-2 transition-colors ${
                  vaoAnalysisCleared
                    ? 'bg-green-100 text-green-700 border border-green-300'
                    : isDropped
                    ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                    : 'bg-gray-200 text-orange-500 hover:bg-gray-300'
                }`}
                disabled={vaoAnalysisCleared || isDropped}
              >
                {vaoAnalysisCleared && <FiCheckCircle className="text-green-600" />}
                <span>VAO Analysis is all clear</span>
              { vaoAnalysisCleared && modifiedBy?.name && (
                  <span className="text-xs text-green-600 font-medium ml-2">
                    (Marked by "{modifiedBy?.name} ({modifiedBy?.role})")
                  </span>
                )}
              </button>
              {vaoAnalysisCleared && (
                <button 
                  onClick={() => handleUndo('vaoAnalysis')} 
                  disabled={isDropped}
                  className={`${isDropped ? 'text-gray-400 cursor-not-allowed' : 'text-blue-500'}`}
                >
                  Undo
                </button>
              )}
            </div>
          </div>

          <div className="w-[70%] flex flex-col gap-2 mt-4">
            <label htmlFor="remarks">Any additional Remarks to note</label>
            <textarea
              id="remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              cols="30"
              rows="4"
              disabled={isDropped}
              className={`w-full border rounded-md mt-2 p-2 ${
                isDropped 
                  ? 'border-gray-300 bg-gray-100 text-gray-500 cursor-not-allowed' 
                  : 'border-gray-300'
              }`}
              placeholder="Enter any additional remarks or notes..."
            />
            <button
              onClick={handleSave}
              disabled={isDropped}
              className={`mt-4 w-full px-4 py-2 rounded-[10px] transition-colors ${
                isDropped 
                  ? 'bg-gray-400 text-gray-600 cursor-not-allowed' 
                  : 'bg-customGreen text-white hover:bg-green-600'
              }`}
            >
              Save
            </button>
          </div>
        </div>
      </div>

      <ConfirmationModal
        showModal={showConfirmModal}
        onCancel={handleCloseModal}
        onConfirm={handleConfirmAction}
        title="Are You Sure?"
        message={`Are you sure you want to mark ${
          pendingAction === 'fma' ? 'FMA' : pendingAction === 'aRecord' ? 'A Record' : 'VAO Analysis'
        } as clear?`}
        confirmText="Yes, I'm sure"
      />
    </div>
  );
};

export default VAOAnalysis;